<template>
  <div id="app" class="app">
    <div id="head" class="t1">
      <div class="logo-div" @click="goIndex">
        <img class="logo" alt="香港商報" src="../../assets/img/logo.png">
      </div>
      <div class="icon-div">

        <van-popover
            v-model="showAppPop" trigger="click" placement="bottom-end"
            :actions="actionsApp" @select="onSelect">
          <template #reference>
            <div class="ll l1">
              <img class="user" alt="应用" src="../../assets/img/nav_icon_app.png">
            </div>
          </template>
        </van-popover>

        <van-popover
            v-model="showPopover" trigger="click" placement="bottom-end"
            :actions="actions" @select="onSelect">
          <template #reference>
            <div class="ll l1">
              <img class="user" alt="用户中心" src="../../assets/img/nav_icon_user.png">
            </div>
          </template>
        </van-popover>

        <div class="ll l2" @click="goSearch">
          <img class="search" alt="搜尋" src="../../assets/img/nav_icon_search.png">
        </div>
      </div>
    </div>

  </div>

</template>

<script>
  import { redirect, baseRedirect } from '@/js/util.js';
  import { Popover } from 'vant';

  import Vue from 'vue';
  Vue.use(Popover);

	import 'vant/lib/popover/style';

  export default {
    name: 'app',
    data () {
      return {
        showPopover: false,
        showAppPop: false,
        // 通过 actions 属性来定义菜单选项
        actions: [],
        actionsApp: [],
      }
    },
    mounted() {
      //获取用户id
      let islogin = localStorage.getItem('userid');
      console.log(' isLogin : ' + islogin)

      //定义用户菜单
      let actionArr = [];
      if(!islogin){ //用户未登陆
        actionArr.push({ text: '登入', id: 0 });
      }
      // actionArr.push({ text: '我的收藏', id: 1 });
      // actionArr.push({ text: '我的评论', id: 2});
      actionArr.push({ text: '爆料', id: 3 });
      actionArr.push({ text: '聯絡我們', id: 4 });
      if(islogin){  //用户已登陆
        actionArr.push({ text: '登出', id: 10 });
      }

      this.actions = actionArr;


      //定义应用菜单
      let actionAppArr = [];
      actionAppArr.push({ text: '時間鏈', id: 20 });
      actionAppArr.push({ text: '訂閱', id: 21 });

      this.actionsApp = actionAppArr;


    },
    components: {
      
    },
    methods: {
      goSearch(){
        redirect('/search.html', 1)
      },
      goIndex(){
        redirect('/index.html', 1)
      },
      onSelect(action) {
        console.log(action.id);
        if(action.id==0){
          redirect('/login.html', 1)
        }else if(action.id==1){
          redirect('/login.html', 1)
        }else if(action.id==3){
          redirect('/broke.html', 1)
        }else if(action.id==4){
          redirect('/contact.html', 1)
        }else if(action.id==10){
          localStorage.removeItem('userid');
          redirect('/index.html', 1)

        }else if(action.id==20){
          redirect('/timechain.html', 1)
        }else if(action.id==21){
          redirect('/subscribe.html', 1)
        }
      },
    }
  }
</script>

<style src="@/style/header.css">
	
</style>


// WEBPACK FOOTER //
// src/list/components/header/header.vue